import type { IRoleRepository } from '@src/domain/rbac/repository/role_repository';

/**
 * Delete Role Use Case
 * Deletes a role from the system
 */
export class DeleteRoleUseCase {
    constructor(private readonly roleRepository: IRoleRepository) { }

    async execute(roleId: string): Promise<void> {
        await this.roleRepository.delete(roleId);
    }
}
